(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      // Pin/hidden are tracked as state so the animation only fires on real
      // transitions, never on every scroll tick (which is what made it janky).
      this.isPinned = false;
      this.isHidden = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.onResizeHandler = this.onResize.bind(this);
      window.addEventListener('resize', this.onResizeHandler, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeHandler);
    }

    // gsap is loaded asynchronously, so resolve it lazily instead of caching it
    // at upgrade time (it may not be ready yet on the first frame).
    get gsap() {
      return typeof gsap !== 'undefined' ? gsap : null;
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onResize() {
      // Recalculate only while the header sits in normal flow; once pinned its
      // rect no longer reflects the document coordinates we compare against.
      if (!this.isPinned) this.calcHeaderCoords();
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollingDown = scrollTop > this.currentScrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop <= this.headerCoords.top) {
        this.reset();
      } else if (scrollTop > this.headerCoords.bottom) {
        this.pin();

        const lockedByMenu =
          this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160;

        if (scrollingDown && !this.preventHide && !lockedByMenu) {
          this.hide();
        } else if (!scrollingDown && !this.preventReveal) {
          this.reveal();
        }
      }

      this.currentScrollTop = scrollTop;
    }

    // Switch the header to sticky positioning. It is set hidden instantly here
    // (not animated) so it never flashes in at the top when first pinned.
    pin() {
      if (this.isPinned) return;
      this.isPinned = true;
      this.isHidden = true;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      if (this.gsap) this.gsap.set(this.header, { yPercent: -100 });
    }

    hide() {
      if (this.isHidden) return;
      this.isHidden = true;
      this.header.classList.add('shopify-section-header-hidden');
      this.slideTo(-100, false);
    }

    reveal() {
      if (!this.isHidden) return;
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
      this.slideTo(0, true);
    }

    reset() {
      if (!this.isPinned && !this.isHidden) return;
      this.isPinned = false;
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'animate');
      if (this.gsap) {
        this.gsap.killTweensOf(this.header);
        this.gsap.set(this.header, { clearProps: 'transform' });
      }
    }

    // gsap gives us interruptible tweens (overwrite) so reversing scroll
    // direction mid-animation glides instead of snapping. Without gsap we fall
    // back to the css `.animate` transition.
    slideTo(yPercent, useTransitionFallback) {
      if (this.gsap) {
        this.header.classList.remove('animate');
        this.gsap.to(this.header, {
          yPercent,
          duration: this.reducedMotion ? 0 : 0.5,
          ease: 'power3.out',
          overwrite: 'auto',
        });
      } else if (useTransitionFallback) {
        this.header.classList.add('animate');
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
